import { CareOrderBabyFormForCareRequirementPage } from './CareOrderBabyFormForCareRequirementPage';
import { CareOrderBabyFormForDateAndTimePage } from './CareOrderBabyFormForDateAndTimePage';
import { CareOrderBabyFormForDetailConfirmationPage } from './CareOrderBabyFormForDetailConfirmationPage';
import { CareOrderBabyFormForPatientInfoPage } from './CareOrderBabyFormForPatientInfoPage';
export class CareOrderBabyFormUConverter {
    static getDataForPatientInfoPage({ careOrderBabyForm, }) {
        const careOrderFormForPatientInfoPage = new CareOrderBabyFormForPatientInfoPage({
            careOrderBabyForm,
        });
        return careOrderFormForPatientInfoPage;
    }
    static getDataForCareRequirementPage({ careOrderBabyForm, }) {
        const careOrderFormForCareRequirementPage = new CareOrderBabyFormForCareRequirementPage({
            careOrderBabyForm,
        });
        return careOrderFormForCareRequirementPage;
    }
    static getDataForDateAndTimePage({ careOrderBabyForm, maxServiceDays, }) {
        const careOrderFormForDateAndTimePage = new CareOrderBabyFormForDateAndTimePage({
            careOrderBabyForm,
            maxServiceDays,
        });
        return careOrderFormForDateAndTimePage;
    }
    static getDataForDetailConfirmationPage({ careOrderBabyForm, maxServiceDays, }) {
        const careOrderFormForDetailConfirmationPage = new CareOrderBabyFormForDetailConfirmationPage({
            careOrderBabyForm,
            maxServiceDays,
        });
        return careOrderFormForDetailConfirmationPage;
    }
}
